// libs
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
// components
import Dashboard from './pages/dashboard/index.js';
import ForgotPassword from './pages/credentials/forgot-password.js';
import Login from './pages/credentials/login.js';
import InventoryList from './pages/inventory/list.js';
import OrderList from './pages/orders/list.js';
import RegisteredUsersList from './pages/registered-users/list.js';
import ShippingPincodeList from './pages/shipping-pincodes/list.js';
import ConfigList from './pages/config/list.js';
import Upload from './pages/uploads/image.js';
import OrgAccounts from './pages/org-accounts/list.js';
import OfferCodeList from './pages/offer-codes/list.js';
import CategoryList from './pages/categories/list.js';
import SizeList from './pages/sizes/list.js';
import ColorList from './pages/colors/list.js';
import Loading from './components/loading.js';
import RoleRoute from './components/role-route.js';
import { AccountProvider } from './context/account-context.js';
import { useAuth } from './context/auth-context.js';

const ProtectedRoutes = ({ token, orgInfo }) => (
	<Routes>
		<Route
			path="/"
			element={(
				<RoleRoute path="/" roleId={orgInfo.roleId}>
					<Dashboard token={token} orgInfo={orgInfo} />
				</RoleRoute>
			)}
		/>
		<Route
			path="/dashboard"
			element={(
				<RoleRoute path="/dashboard" roleId={orgInfo.roleId}>
					<Dashboard token={token} orgInfo={orgInfo} />
				</RoleRoute>
			)}
		/>
		<Route
			path="/uploads"
			element={(
				<RoleRoute path="/uploads" roleId={orgInfo.roleId}>
					<Upload token={token} orgInfo={orgInfo} />
				</RoleRoute>
			)}
		/>
		<Route
			path="/inventory"
			element={(
				<RoleRoute path="/inventory" roleId={orgInfo.roleId}>
					<InventoryList token={token} orgInfo={orgInfo} />
				</RoleRoute>
			)}
		/>
		<Route
			path="/orders"
			element={(
				<RoleRoute path="/orders" roleId={orgInfo.roleId}>
					<OrderList token={token} orgInfo={orgInfo} />
				</RoleRoute>
			)}
		/>
		<Route
			path="/config"
			element={(
				<RoleRoute path="/config" roleId={orgInfo.roleId}>
					<ConfigList token={token} orgInfo={orgInfo} />
				</RoleRoute>
			)}
		/>
		<Route
			path="/org-accounts"
			element={(
				<RoleRoute path="/org-accounts" roleId={orgInfo.roleId}>
					<OrgAccounts token={token} orgInfo={orgInfo} />
				</RoleRoute>
			)}
		/>
		<Route
			path="/registered-user"
			element={(
				<RoleRoute path="/registered-user" roleId={orgInfo.roleId}>
					<RegisteredUsersList token={token} orgInfo={orgInfo} />
				</RoleRoute>
			)}
		/>
		<Route
			path="/shipping-pincode"
			element={(
				<RoleRoute path="/shipping-pincode" roleId={orgInfo.roleId}>
					<ShippingPincodeList token={token} orgInfo={orgInfo} />
				</RoleRoute>
			)}
		/>
		<Route
			path="/offer-codes"
			element={(
				<RoleRoute path="/offer-codes" roleId={orgInfo.roleId}>
					<OfferCodeList token={token} orgInfo={orgInfo} />
				</RoleRoute>
			)}
		/>
		<Route
			path="/categories"
			element={(
				<RoleRoute path="/categories" roleId={orgInfo.roleId}>
					<CategoryList token={token} orgInfo={orgInfo} />
				</RoleRoute>
			)}
		/>
		<Route
			path="/sizes"
			element={(
				<RoleRoute path="/sizes" roleId={orgInfo.roleId}>
					<SizeList token={token} orgInfo={orgInfo} />
				</RoleRoute>
			)}
		/>
		<Route
			path="/colors"
			element={(
				<RoleRoute path="/colors" roleId={orgInfo.roleId}>
					<ColorList token={token} orgInfo={orgInfo} />
				</RoleRoute>
			)}
		/>
		<Route path="*" element={<Navigate to="/dashboard" replace />} />
	</Routes>
);

const App = () => {
	const { token, orgInfo, loading, isAuthenticated } = useAuth();

	if (loading) {
		return (
			<div className="d-flex justify-content-center align-items-center vh-100">
				<Loading />
			</div>
		);
	}

	return (
		<Routes>
			<Route
				path="/login"
				element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />}
			/>
			<Route
				path="/forgot-password"
				element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <ForgotPassword />}
			/>
			<Route
				path="/*"
				element={
					isAuthenticated ? (
						<AccountProvider token={token} orgInfo={orgInfo}>
							<ProtectedRoutes token={token} orgInfo={orgInfo} />
						</AccountProvider>
					) : (
						<Navigate to="/login" replace />
					)
				}
			/>
		</Routes>
	);
};

export default App;
